import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { type Location, type PaxCount } from '@utils/types';
import { type ReserveType } from '@utils/itinerary';

export type UrlStringParams<T> = {
    [k in keyof T]?: string;
};

export enum SearchFromErrorMessage {
    DuplicatePath = 'DuplicatePath',
}

export interface LocationGroup<T extends Location<T> = Location> {
    title: string | null;
    locations: T[];
    icon?: IconDefinition;
    ignoreGroupInSearch?: boolean;
}
export type PaxModel = {
    title?: string;
    deleteAble?: boolean;
    paxList: PaxCount[];
};

export type searchHistoryItem = {
    originName: string;
    destinationName: string;
    viewUrl: string;
    reserveType: ReserveType;
    departureDate: string;
    returnDate?: string;
    expireDate: string;
};

export type dayChangerFunc = (params: { query: any; path: string }) => void;

export interface SearchSuggestionResult {
    viewUrl: string;
    originTitle?: string;
    destinationTitle: string;
    minPrice?: number;
}

export type SearchSuggestionItem = {
    viewUrl?: string;
    title: string;
    isLoading?: boolean;
    isDisabled?: boolean;
    isSelected?: boolean;
    icon: IconDefinition;
};
